import { useState } from "react";
import { ThumbsUp, Clock, History } from "lucide-react";

export type SortOption = "latest" | "popular" | "random";

interface TipSortControlsProps {
  sortBy: SortOption;
  onSortChange: (option: SortOption) => void;
}

export function TipSortControls({ sortBy, onSortChange }: TipSortControlsProps) {
  console.log("TipSortControls rendering with sortBy:", sortBy);

  const playSound = () => {
    const audio = new Audio("/sfx/sort.aac");
    audio.play();
  };

  const handleClick = (option: SortOption) => {
    playSound();
    onSortChange(option);
  };

  return (
    <div className="flex justify-center gap-2 buttonGG">
      {["popular", "latest", "random"].map((option) => (
        <div
          key={option}
          className={sortBy === option ? "votedActive_button" : "voted_button"}
          onClick={() => handleClick(option as SortOption)}
        >
          <div className={sortBy === option ? "votedActive_button-insideG" : "voted_button-insideG"}>
            <div className={sortBy === option ? "votedActive_button-insideBorder" : "voted_button-insideBorder"}></div>
            <div className={sortBy === option ? "votedActive_button-inside" : "voted_button-inside"}>
              <img src="/imgs/light.png" alt="img" className="voted_button-img" />
              <span className="voted_button-text absolute font-Metric">
                {option === "popular" ? "Most Voted" : option === "latest" ? "Latest Tips" : "Random Tips"}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}